import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Truck, Package, Mail, Zap, MapPin, Info } from 'lucide-react';

const ShippingPolicy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div>
      <section className="bg-gradient-to-b from-[#efe9db] to-[#faf7f1]">
        <div className="max-w-4xl mx-auto px-6 py-16 md:py-24 text-center">
          <div className="inline-flex items-center gap-2 uppercase tracking-[0.35em] text-xs text-[#7a8b6b] mb-4">
            <Truck className="w-4 h-4" /> Shipping
          </div>
          <h1 className="font-serif-elegant text-5xl md:text-6xl mb-4">Shipping Policy</h1>
          <p className="text-[#4a4640] max-w-2xl mx-auto leading-relaxed">
            At Herbs We Love, we are committed to getting your order to you quickly and safely.
          </p>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-12 space-y-10">
        <section>
          <div className="flex items-center gap-2 mb-3">
            <Package className="w-5 h-5 text-[#7a8b6b]" />
            <h2 className="font-serif-elegant text-3xl">Order Processing</h2>
          </div>
          <ul className="space-y-2 text-[#4a4640] leading-relaxed pl-7 list-disc">
            <li>Orders are processed and shipped twice a week &mdash; every Monday and Wednesday.</li>
            <li>Orders placed after 5:00 PM PST the day before shipping will be shipped on the next available shipping day.</li>
          </ul>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-4">
            <Truck className="w-5 h-5 text-[#7a8b6b]" />
            <h2 className="font-serif-elegant text-3xl">Shipping Options &amp; Rates</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-[#faf7f1] border border-[#e5decf] p-6">
              <div className="flex items-center gap-2 mb-2">
                <Truck className="w-4 h-4 text-[#3a4a3b]" />
                <div className="font-serif-elegant text-xl">Standard Shipping</div>
              </div>
              <div className="text-[#4a4640] text-sm mb-1">Delivery Time: 3&ndash;7 business days</div>
              <div className="font-serif-elegant text-2xl text-[#3a4a3b]">Flat Rate: $12</div>
            </div>
            <div className="bg-[#efe9db] border border-[#c9c1ad] p-6">
              <div className="flex items-center gap-2 mb-2">
                <Zap className="w-4 h-4 text-[#3a4a3b]" />
                <div className="font-serif-elegant text-xl">Express Shipping</div>
              </div>
              <div className="text-[#4a4640] text-sm mb-1">Delivery Time: 1&ndash;3 business days</div>
              <div className="font-serif-elegant text-2xl text-[#3a4a3b]">Flat Rate: $25</div>
            </div>
          </div>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <Package className="w-5 h-5 text-[#7a8b6b]" />
            <h2 className="font-serif-elegant text-3xl">Order Tracking</h2>
          </div>
          <p className="text-[#4a4640] leading-relaxed">
            Once your order has shipped, you will receive an email confirmation with tracking information.
          </p>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <MapPin className="w-5 h-5 text-[#7a8b6b]" />
            <h2 className="font-serif-elegant text-3xl">Shipping Locations</h2>
          </div>
          <p className="text-[#4a4640] leading-relaxed">
            We currently ship within the United States.
          </p>
        </section>

        <section>
          <div className="flex items-center gap-2 mb-3">
            <Info className="w-5 h-5 text-[#7a8b6b]" />
            <h2 className="font-serif-elegant text-3xl">Delays</h2>
          </div>
          <p className="text-[#4a4640] leading-relaxed">
            Please note that shipping times are estimates and may be impacted by carrier delays,
            holidays, or weather events.
          </p>
        </section>

        <section className="bg-[#efe9db] p-8 text-center">
          <Mail className="w-6 h-6 mx-auto text-[#3a4a3b] mb-3" />
          <h3 className="font-serif-elegant text-2xl mb-2">Questions about your order?</h3>
          <p className="text-[#4a4640] mb-4">Reach us anytime and we&rsquo;ll be in touch.</p>
          <a href="mailto:connectwithanherbalist@outlook.com" className="btn-primary inline-flex items-center gap-2">
            <Mail className="w-4 h-4" /> connectwithanherbalist@outlook.com
          </a>
        </section>

        <div className="text-center pt-6">
          <Link to="/collections/all" className="btn-outline">Back to Shop</Link>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
